import { counterpartApiConnector } from 'apiConnector/counterpart/counterpart';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { ComponentType, useCallback } from 'react';
import type { Observable } from 'rxjs';
import { httpClient } from 'utils/http/httpClient';

import type { FilteringResultArray } from '../GenericTypeahead/Typeahead.models';
import type { ISalesCounterPartTypeaheadProps } from './SalesCounterpartTypeAhead';
import { SalesCounterpartTypeahead as TypeAhead } from './SalesCounterpartTypeAhead';

const counterpartApi = counterpartApiConnector(httpClient);

export const withFilterApi =
  <P extends ISalesCounterPartTypeaheadProps>(
    Component: ComponentType<P>,
  ): ComponentType<Pick<P, Exclude<keyof P, 'onFilter'>>> =>
  props => {
    const onFilter = useCallback((input: string) => {
      const result = counterpartApi.fetchSalesCounterparts(input);
      return result as unknown as Observable<FilteringResultArray<ISalesCounterpart>>;
    }, []);

    // @ts-ignore: TS2322
    return <Component {...props} onFilter={onFilter} />;
  };

export const SalesCounterpartTypeahead = withFilterApi(TypeAhead);
